<template>
  <div class="manage-default-box">
    <div class="main-box clear-both">
      <LeftNav :status='1'></LeftNav>
      <div class="order-display-box">
        <h2>注文一覧</h2>
        <div class="order-info-box">
          <div class="info-box order-box">
            <p class="title">注文</p>
            <p class="list-num">{{ order_num }}</p>
          </div>
          <div class="info-box accept-box">
            <p class="title">受付済み</p>
            <p class="list-num">{{ accept_num }}</p>
          </div>
          <div class="info-box production-box">
            <p class="title c-c-dark">製造中</p>
            <p class="list-num">{{ product_num }}</p>
          </div>
          <div class="info-box shipping-box">
            <p class="title">発送済み</p>
            <p class="list-num">{{ shipping_num }}</p>
          </div>
          <div class="info-box cancel-box">
            <p class="title">キャンセル</p>
            <p class="list-num">{{ cancel_num }}</p>
          </div>
        </div>
        <div class="order-list-box">
          <div class="tab-button-box">
            <div v-for="item in tab_button_list"
              :key="item.id"
              v-bind:class="{'tab-button-selected': current_tab_id == item.id}"
              class="tab-button"
              @click="tab_click(item.id)"
            >{{ item.title }}</div>
          </div>
          <div class="paging-box">
            <div v-if="current_tab_id == 4 && shipping_page_all_num > 1" class="paging-sub-box">
              <div @click="page_shift(-1)">＜</div>
              <input type="text" v-model="page_num" @change="page_change()">
              <p>／</p>
              <p>{{ shipping_page_all_num }}</p>
              <div @click="page_shift(1)">＞</div>
            </div>
          </div>
          <div class="tab-list-box">
            <div v-if="current_tab_id == 1">
              <OrderListTab :list="current_tab_list_order" :tab_id="1"  :cb_f="reload"></OrderListTab>
            </div>
            <div v-if="current_tab_id == 2">
              <OrderListTab :list="current_tab_list_accept" :tab_id="2"  :cb_f="reload"></OrderListTab>
            </div>
            <div v-if="current_tab_id == 3">
              <OrderListTab :list="current_tab_list_product" :tab_id="3"  :cb_f="reload"></OrderListTab>
            </div>
            <div v-if="current_tab_id == 4">
              <OrderListTab :list="current_tab_list_shipping" :tab_id="4" :cb_f="reload"></OrderListTab>
            </div>
            <div v-if="current_tab_id == 5">
              <OrderListTab :list="current_tab_list_cancel" :tab_id="5" :cb_f="reload"></OrderListTab>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from '@/views/components/manage/LeftNav';
import OrderListTab from '@/views/components/manage/OrderListTab';

export default {
  name: 'manageDefault',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    LeftNav,
    OrderListTab
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      current_tab_id: 1,
      page_num: 1,
      step: 500,// 1ページの表示数
      list: [],
      tab_button_list: [{id: 1, title: '注文'}, {id: 2, title: '受付済み'}, {id: 3, title: '製造中'}, {id: 4, title: '発送済み'}, {id: 5, title: 'キャンセル'}],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    current_tab_list_all () { return this.list; },
    current_tab_list_order () {
      return this.list.filter(function(el) {
        return el.status == 1;
      }, this);
    },
    current_tab_list_accept () {
      return this.list.filter(function(el) {
        return el.status == 2;
      }, this);
    },
    current_tab_list_product () {
      return this.list.filter(function(el) {
        return el.status == 3;
      }, this);
    },
    current_tab_list_shipping () {
      let shipping_list = this.list.filter(function(el) {
        return el.status == 4;
      }, this);
      let start_page = (this.page_num - 1) * this.step;
      return shipping_list.slice(start_page, start_page + this.step);
    },
    current_tab_list_shipping_all () {
      return this.list.filter(function(el) {
        return el.status == 4;
      }, this);
    },
    current_tab_list_cancel () {
      return this.list.filter(function(el) {
        return el.status == 5;
      }, this);
    },
    order_num () { return this.current_tab_list_order.length; },
    accept_num () { return this.current_tab_list_accept.length; },
    product_num () { return this.current_tab_list_product.length; },
    shipping_num () { return this.current_tab_list_shipping_all.length; },
    shipping_page_all_num () { return Math.ceil(this.current_tab_list_shipping_all.length / this.step); },
    cancel_num () { return this.current_tab_list_cancel.length; },
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.current_tab_id = this.$store.getters['mOrderList/selected_tab_id'];
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    this.load_data();
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    load_data () {
      let ld = new this.$loader(this);
      ld._m_data_set({token: this.$store.getters['mLoginInfo/login_token']});
      ld._post_cb_f = this.order_list_get_cb;
      ld._load_start('manage/order_list_get.php');
    },
    tab_click (tab_id) {
      this.current_tab_id = tab_id;
      this.$store.commit('mOrderList/set_selected_tab_id', tab_id);
    },
    order_list_get_cb (data) {
      if (data.res === 1) {
        this.list = data.data.list;
      } else {
        this.$alert('alert', `エラーコード：${data.data.res}`);
      }
    },
    page_change () {
      if (this.shipping_page_all_num < this.page_num) {
        this.page_num = this.shipping_page_all_num;
      }
    },
    page_shift (num) {
      let check_num = this.$lib._pint(this.page_num) + num;
      if (check_num > 0 && check_num <= this.shipping_page_all_num) {
        this.page_num = check_num;
      }
    },
    page_num_check () {
      let shipping_list = this.list.filter(function(el) {
        return el.status == 4;
      }, this);
      let start_page = (this.page_num - 1) * this.step;
      if (shipping_list.length != 0 && start_page >= shipping_list.length) {
        // ステータスの変更で数が変更されるため、このページが表示できるかチェック
        this.page_num = this.shipping_page_all_num;
      }
    },
    reload () {
      this.load_data();
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.manage-default-box {
  .main-box {
    display: flex;
  }
  .order-display-box {
    min-width: 1108px;
    flex: 1;
    padding: 16px;
    .order-info-box {
      display: flex;
      margin: 0 auto;
      // width: 554px;
      justify-content: center;
      .info-box {
        margin: 23px 8px;
        width: 120px;
        height: 80px;
        background-color: #f4f4e5;
        .title {
          font-size: 1rem;
          font-weight: 800;
          margin: 8px;
          padding: 2px 0;
          border-bottom: 1px solid #d7d7c5;
          width: 110px;
        }
        .list-num {
          color: #7a7d74;
          margin: 0 auto;
          font-size: 1.6rem;
          width: 100px;
          font-weight: bold;
          line-height: 1;
        }
      }
      .order-box {
        .title {
          color: #107ca0;
        }
      }
      .accept-box {
        .title {
          color: #bb130c;
        }
      }
      .production-box {
        .title {
          color: #14a55c;
        }
      }
      .shipping-box {
        .title {
          color: #bb870f;
        }
      }
      .cancel-box {
        .title {
          color: #666666;
        }
      }
    }
    .order-list-box {
      margin: 4px auto 0 auto;
      .tab-button-box {
        display: flex;
        justify-content: center;
        margin: 0 auto;
        width: 1100px;
        .tab-button {
          width: 120px;
          height: 40px;
          margin:  0 8px;
          line-height: 40px;
          font-size: 1rem;
          border: none;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          background-color: #cecebb;
          color: #FFF;
          font-weight: bold;
          cursor: pointer;
        }
        .tab-button:last-child {
          margin-right: 8px;
        }
        div.tab-button:not(.tab-button-selected):hover {
          background-color: #738f53;
        }
        .tab-button-selected {
          background-color: #588f1a;
        }
      }
      .paging-box {
        width: 1100px;
        margin: 0 auto;
        .paging-sub-box {
          margin-top: -35px;
          float: right;
          width: 250px;
          display: flex;
          justify-content: center;
          align-items: center;
          input[type="text"] {
            text-align: right;
            height: 30px;
            width: 40px;
          }
          div {
            padding: 0 25px;
            margin: 0 10px;
            height: 30px;
            line-height: 32px;
            text-align: center;
            background-color: #cfcebc;
            border-radius: 5px;
            color: #FFF;
            font-weight: bold;
            cursor: pointer;
          }
          div:hover {
            background-color: #738f53;
          }
        }
      }
      .tab-list-box {
        width: 100%;
      }
    }
  }
}
</style>
